import { request } from 'utils/request';
import {
  IEditTask,
  IFieldUpdate,
  IGetTaskListParams,
  ITaskFields,
} from './slice/types';

const taskApi = {
  getTasks: (
    hiikoEnvironmentId: number,
    { companyGroupId, ...params }: IGetTaskListParams,
  ) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task`,
      params: {
        ...params,
        company_group_id: companyGroupId ?? undefined,
      },
    });
  },

  getTaskNotes: (hiikoEnvironmentId: number, taskId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/note`,
    });
  },

  editTask: (hiikoEnvironmentId: number, data: IEditTask, taskId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}`,
      method: 'POST',
      data,
    });
  },

  addFields: (
    hiikoEnvironmentId: number,
    data: ITaskFields,
    taskId: number,
  ) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/add-fields`,
      method: 'POST',
      data,
    });
  },

  getTaskCategories: (hiikoEnvironmentId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task_category`,
    });
  },

  getTaskDetails: (hiikoEnvironmentId: number, taskId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}`,
    });
  },

  progressUpdate: (
    hiikoEnvironmentId: number,
    data: { fieldTaskProgressUpdateViews: IFieldUpdate[] },
    taskId: number,
  ) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/update-progress`,
      method: 'POST',
      data,
    });
  },

  getTaskPlannedResources: (hiikoEnvironmentId: number, taskId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/planned-resources`,
    });
  },

  addTaskPlannedResource: ({
    hiikoEnvironmentId,
    taskId,
    norm,
    resourceId,
  }: {
    hiikoEnvironmentId: number;
    taskId: number;
    norm: number;
    resourceId: number;
  }) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/planned-resources`,
      data: { norm, resourceId },
    });
  },

  updateTaskPlannedResource: ({
    hiikoEnvironmentId,
    taskId,
    norm,
    resourceId,
  }: {
    hiikoEnvironmentId: number;
    taskId: number;
    norm: number;
    resourceId: number;
  }) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/planned-resources/${resourceId}`,
      data: norm,
    });
  },

  deleteTaskPlannedResource: ({
    hiikoEnvironmentId,
    taskId,
    resourceId,
  }: {
    hiikoEnvironmentId: number;
    taskId: number;
    resourceId: number;
  }) => {
    return request({
      method: 'DELETE',
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/planned-resources/${resourceId}`,
    });
  },

  getTaskUsedResources: (hiikoEnvironmentId: number, taskId: number) => {
    return request({
      url: `hiiko_environment/${hiikoEnvironmentId}/task/${taskId}/used-resources`,
    });
  },

  addTaskUsedResource: (
    usedResources: {
      amount: number;
      resourceId: number;
      fieldTaskId: number;
    }[],
    hiikoEnvironmentId: number,
  ) => {
    return request({
      method: 'POST',
      url: `hiiko_environment/${hiikoEnvironmentId}/task/used-resources`,
      data: usedResources,
    });
  },
};

export default taskApi;
